import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-right-modal',
  templateUrl: './right-modal.component.html',
  styleUrls: ['./right-modal.component.scss']
})
export class RightModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
